import { render, staticRenderFns } from "./TechnicalFeaturesRoof.vue?vue&type=template&id=10dad4ae"
import script from "./TechnicalFeaturesRoof.vue?vue&type=script&lang=js"
export * from "./TechnicalFeaturesRoof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports